import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import dashboardApi from 'services/api/dashboard'

export const fetchEmailLogs = createAsyncThunk(
  'emailLogs/fetchEmailLogs',
  async ({
    merchantId,
    subsidiaryId,
    kinds,
    fromDate = null,
    toDate = null,
    emailAddress = null
  }) => {
    const emails = await dashboardApi.getEmailLogs({
      merchantId,
      subsidiaryId,
      kinds,
      fromDate,
      toDate: `${toDate} 23:59:59`,
      emailAddress
    })

    return {
      emails,
      currentSubsidiaryId: subsidiaryId
    }
  }
)

const initialState = {
  isLoading: true,
  isErred: false,
  emails: {
    invoice: [],
    invite: [],
    login: [],
    incoming: []
  }
}

function getEmailKey({ kind }) {
  const invoiceKinds = [
    'SubsidiaryInvoiceForReconciliation',
    'SubsidiaryInvoiceForPayment',
    'SubsidiaryInvoiceForPaymentLate',
    'SubsidiaryInvoiceForPaymentLateMuch',
    'SubsidiaryInvoicePayment'
  ]

  const inviteKinds = ['Invite']

  const loginKinds = ['OwnershipVerification', 'Welcome', 'LoginMagicLink']

  const incomingKinds = ['Incoming']

  if (invoiceKinds.includes(kind)) {
    return 'invoice'
  }

  if (inviteKinds.includes(kind)) {
    return 'invite'
  }

  if (loginKinds.includes(kind)) {
    return 'login'
  }

  if (incomingKinds.includes(kind)) {
    return 'incoming'
  }
}

const emailLogsSlice = createSlice({
  name: 'emailLogs',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchEmailLogs.pending]: state => {
      state.isLoading = true
      state.emails = { invoice: [], invite: [], login: [], incoming: [] }
      state.isErred = false
    },
    [fetchEmailLogs.fulfilled]: (state, action) => {
      state.isLoading = false
      state.isErred = false
      state.emails = action.payload.emails.reduce(
        (prev, curr) => {
          const emailKey = getEmailKey(curr)

          if (
            emailKey === 'invoice' &&
            curr.subsidiaryId !== action.payload.currentSubsidiaryId
          ) {
            return prev
          }

          return {
            ...prev,
            [emailKey]: [
              ...(prev[emailKey] ?? []),
              {
                ...curr,
                searchString: curr.from + ' ' + curr.to + ' ' + curr.subject
              }
            ]
          }
        },
        { invoice: [], invite: [], login: [], incoming: [] }
      )
    },
    [fetchEmailLogs.rejected]: state => {
      state.isLoading = false
      state.emails = { invoice: [], invite: [], login: [] }
      state.isErred = true
    }
  }
})

export default emailLogsSlice
